import WixSDK from 'shared/utils/wix-sdk';
import { sendPerformanceInfo, addSingleMeasurement } from 'shared/utils/performance';
import types from 'shared/utils/performance/types';
import applicationNames from 'shared/constants/application-names';
import { getApplicationName } from 'shared/selectors/configuration';

import { NAMES as SERVER_CHANNEL_VIDEOS_LIST } from 'shared/redux/server/actions/channel/videos/list';
import { NAMES as SERVER_CHANNEL_GET } from 'shared/redux/server/actions/channel/get';

const middleware = store => next => action => {
  const result = next(action); // eslint-disable-line callback-return

  if (getApplicationName(store.getState()) !== applicationNames.WIDGET) {
    return result;
  }

  switch (action.type) {
    case SERVER_CHANNEL_GET.START:
      addSingleMeasurement(types.appFirstPreview);
      WixSDK.Performance.applicationLoadingStep(0, 'loading preview');
      break;
    case SERVER_CHANNEL_GET.SUCCESS:
      WixSDK.Performance.applicationLoadingStep(1, 'loading content');
      break;
    case SERVER_CHANNEL_VIDEOS_LIST.SUCCESS:
      addSingleMeasurement(types.appFullyRendered);
      sendPerformanceInfo();
      break;
    default:break;
  }

  return result;
};

export default middleware;



// WEBPACK FOOTER //
// ./src/widget/redux/performance-middleware.js